import React, { useEffect } from 'react';
import { Container, Row, Col, Image, Card } from 'react-bootstrap';
import Myimage from './Assets/Myimage.jpeg';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: 'lavender' }}>
    <div className="main">
    <Container>
      <Row className='py-5' style={{height:'100vh'}}>
      <Col xs={12} md={6} >
        <div className='mt-5'>
          <h5>Hi There.! <i className="fa-regular fa-face-smile"></i></h5>
          <h3>I'm</h3>
          <h1><strong>ARE NAVEEN KUMAR</strong></h1>
          <h3>and I'm a Full Stack Developer</h3>
        </div>
      </Col>
      <Col xs={12} md={6} className="text-center mt-5">
        <div className="m-3 flex-grow-1">
          <h1><strong>FIND ME ON</strong></h1>
          <div className='d-flex justify-content-center'>
            <a href="http://www.linkedin.com/in/arenaveenkumar" target="_blank" rel="noopener noreferrer">
              <i className="icon fab fa-linkedin-in fs-3 m-3 p-2 rounded-5 bg-primary text-white"></i>
            </a>
            <a href="https://github.com/arenaveenkumar" target="_blank" rel="noopener noreferrer">
              <i className="icon fab fa-github fs-3 m-3 p-2 rounded-5 bg-white"></i>
            </a>
          </div>
          <h5>Happy to connect with you.!</h5>
        </div>
      </Col>
    </Row>
      </Container>

    </div>

      <div className='py-5' style={{ backgroundColor: '#f6f5ff' }}>
        <center><h1 className=''>ABOUT ME</h1></center>
        <Container>
          <Row className="about">
            <Col sm={12} md={6}>
              <p className='fs-4 fw- mt-5'>Hi👋🏻 I am a FULL Stack Web developer, with skills HTML, CSS, JavaScript, BootStrap, React, Node.js and MySQL</p>
            </Col>
            <Col sm={12} md={6} className="text-center">
              <div style={{ maxWidth: '245px', maxHeight: '245px', overflow: 'hidden', borderRadius: '50%', margin: 'auto' }}>
                <Image src={Myimage} style={{ width: '100%', height: 'auto' }} fluid alt="Missing" />
              </div>
            </Col>
          </Row>
        </Container>
        <hr />

        <div className="languages mt-5">
          <center><h1 className='fw-bold'>SCRIPTING LANGUAGES</h1></center>
          <div className="languages1 d-flex justify-content-center flex-wrap">
            <i className="fab fa-html5 rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
            <i className="fab fa-css3-alt rounded-3 p-4 border border-primary  m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
            <i className="fab fa-bootstrap rounded-3 p-3 border border-primary  m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          </div>


          <center><h1 className='fw-bold mt-5'>PROGRAMMING LANGUAGES</h1></center>
          <div className="languages1 d-flex justify-content-center flex-wrap">
            <i className="fab fa-java rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
            <i className="fab fa-square-js rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          </div>

          <center><h1 className='fw-bold mt-5'>FRAMEWORKS</h1></center>
          <div className="languages1 d-flex justify-content-center flex-wrap">
            <i className="fab fa-node rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
            <i className="fab fa-react rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          </div>

          <center><h1 className='fw-bold mt-5'>DATABASE</h1></center>
          <div className="languages1 d-flex justify-content-center">
            <img src="https://cdn.iconscout.com/icon/free/png-512/free-mysql-3628352-3032187.png?f=webp&w=512" alt="" srcset="" className="fab fa-mysql rounded-3 p-4 border border-primary m-3 icon" style={{ width: '8rem', margin: '10px' }} />
          </div>

          <center><h1 className='fw-bold mt-5'>VERSION CONTROL</h1></center>
          <div className="languages1 d-flex justify-content-center">
            <i className="fab fa-github rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          </div>

          <center><h1 className='fw-bold mt-5'>OPERATING SYSTEMS</h1></center>
          <div className="languages1 d-flex justify-content-center flex-wrap">
            <i className="fab fa-windows rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
            <i className="fab fa-apple rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
            <i className="fab fa-linux rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
            <i className="fab fa-ubuntu rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
            <i class="fa-brands fa-android rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          </div>
        </div>


        <div className="contact">
          <Card className="text-center contact-card mt-5" style={{ backgroundColor: '#f6f5ff' }}>
            <Card.Body>
              <Card.Title><h1>Contact <hr /></h1></Card.Title>
              <Row xs={1} md={2} lg={4} className="g-4">
                <Col>
                  <div className="contact-info">
                    <h2><i className="fa-solid fa-phone fs-4"></i> Mobile</h2>
                    <h5>+91 8096858075</h5>
                  </div>
                </Col>
                <Col>
                  <div className="contact-info">
                    <h2><i className="fa-solid fa-envelope"></i> Email</h2>
                    <h5>naveenkumarare66@gmail.com</h5>
                  </div>
                </Col>
                <Col>
                  <div className="contact-info">
                    <h2><i class="fa-brands fa-whatsapp" style={{ color: 'var(--bs-success)' }}></i> WhatsApp</h2>
                    <h5><a className='btn btn-outline-success rounded' href="https://wa.me/918096858075" target="_blank" rel="noopener noreferrer">Message</a></h5>
                  </div>
                </Col>
                <Col>
                  <div className="contact-info">
                    <h2><i className="fa-brands fa-linkedin" style={{ color: 'var(--bs-primary)' }}></i> LinkedIn</h2>
                    <h5><a className='btn btn-outline-primary ' href="https://www.linkedin.com/in/arenaveenkumar/" target="_blank" rel="noopener noreferrer">Connect</a></h5>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
        <br /> <br />
        <div className="footer1 bg-secondary text-white p-3">
          <Container className="px-0">
            <Row className="justify-content-center align-items-center">
              <Col xs={12} sm={4} className="mb-3 mb-sm-0 text-center text-sm-start">
                <h6>Designed & Developed by <a href="https://www.linkedin.com/in/arenaveenkumar" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}><strong className='text-warning'>ARE NAVEEN KUMAR</strong></a></h6>
              </Col>
              <Col xs={12} sm={4} className="text-center mb-4 mb-sm-0">
                <h6 className="mb-0"><i className="fa-regular fa-copyright "></i> Copyright-2024</h6>
              </Col>
              <Col xs={12} sm={4} className="d-flex justify-content-center justify-content-sm-end">
                <a href="https://www.linkedin.com/in/arenaveenkumar/" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-linkedin-in fs-4"></i></a>
                <a href="https://github.com/arenaveenkumar" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-github fs-4"></i></a>
                <a href="https://www.instagram.com/arenaveenkumar_" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram fs-4"></i></a>
                <a href="https://wa.me/918096858075" className="text-white" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp fs-4"></i></a>

              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
}
